module.exports = __webpack_public_path__ + "media/payment_icons/paypal-176d3ebd.svg";